import { render, staticRenderFns } from "./app-toolbar.vue?vue&type=template&id=2b2ce06e&scoped=true&"
import script from "./app-toolbar.vue?vue&type=script&lang=js&"
export * from "./app-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./app-toolbar.vue?vue&type=style&index=0&id=2b2ce06e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ce06e",
  null
  
)

export default component.exports